import { injectable } from '@servicetitan/react-ioc';
import { NotificationsService } from '@servicetitan/notifications';

import { ConfigResponse } from '../api/eh.api';

@injectable()
export class SettingsStore {
    private settings = new Map<string, string>();

    constructor(private readonly notificationsService: NotificationsService) {}

    initializeSettings = (appSettings: ConfigResponse) => {
        try {
            this.settings = new Map<string, string>(Object.entries(appSettings));
        } catch (err) {
            this.notificationsService.error({
                title: 'Application Error',
                message: 'Unable to parse settings',
            });
            throw new Error('Unable to parse settings');
        }
    };

    getSetting = (key: string) => {
        const setting = this.settings.get(key);
        if (setting) {
            return setting;
        }
        this.notificationsService.error({
            title: 'Application Error',
            message: `Missing Required Setting ${key}`,
        });
        throw new Error(`Missing Required Setting ${key}`);
    };
}
